import type { Ordinances } from '@fs/zion-tree-types'
import { useGroupsContext } from '@fs/zion-tree-groups'
import useEffectiveUserId from '../hooks/useEffectiveUserId'
import { type SwrCustomizedResponse, useSwrRequest } from './useSwrRequest'
import { readOrdinances } from './emulators/ordinancesBE'
import useFocusPerson from './useFocusPerson'
import { useShowTempleContext } from '../providers/ShowTempleContext'

export const swrKey = (personId: string, cpUserId: string, treeId: string): string =>
  `/service/tree/tree-data/reservations/person/${personId}/ordinances?pendingTransfer=true&owner=${cpUserId}&treeId=${treeId}&enforceTemplePolicyEx=true`

export default function useOrdinances(): SwrCustomizedResponse<Ordinances, 'ordinances'> {
  const { focusPerson } = useFocusPerson()
  const { effectiveUserId } = useEffectiveUserId()
  const { currentTreeId } = useGroupsContext()
  const [showTemple] = useShowTempleContext()
  const personId = focusPerson?.id
  const treeId = currentTreeId || 'PRIVATE'

  const {
    data: ordinances,
    error,
    isLoading,
    isValidating,
    mutate: mutateOrdinances,
  } = useSwrRequest<Ordinances>(
    effectiveUserId && personId && showTemple ? swrKey(personId, effectiveUserId, treeId) : null,
    undefined,
    {
      emulator: readOrdinances,
    }
  )

  return { ordinances, error, isLoading, isValidating, mutateOrdinances }
}
